import { Link } from "@/components/common/Link";
export default function SiteFooter() {
  return <section data-section-id="7008" id="footer" className="bg-[#0A0A0A] py-16 dark">
      <div className="max-w-3xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {}
          <div className="flex flex-col items-start gap-4 !bg-[url(https://definite-toad.10web.cloud/wp-content/uploads/2026/03/BLKN-Logo-White.png)]">
            <Link to="/HomePage" className="block">
              <img src="https://blkn.com.au/wp-content/uploads/2026/03/BLKN-Logo-White-Marginised.png" alt="BLKN" className="h-10 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-[12px] font-medium text-[#E5E5E5] uppercase tracking-wider">© 2024&nbsp;BLKN. ALL RIGHTS RESERVED.</p>
          </div>

          {}
          <div className="flex flex-col items-start gap-3">
            <span className="text-[12px] font-black text-[#E5E5E5] uppercase tracking-tighter">CONTACT</span>
            <div className="flex flex-col gap-1.5">
              <Link to="#" className="text-[12px] font-bold text-[#E5E5E5] underline decoration-[#E5E5E5]/30 hover:decoration-[#E5E5E5] transition-colors uppercase tracking-widest">INFO@BLKN.COM.AU</Link>
              
            </div>
          </div>

          {}
          <div className="flex flex-col items-start gap-3">
            <span className="text-[12px] font-black text-[#E5E5E5] uppercase tracking-tighter">Legal</span>
            <div className="flex flex-col gap-1.5">
              <Link to="#" className="text-[12px] font-medium text-[#E5E5E5] underline decoration-[#E5E5E5]/30 hover:decoration-[#E5E5E5] transition-colors uppercase">
                Privacy Policy
              </Link>
              <Link to="#" className="text-[12px] font-medium text-[#E5E5E5] underline decoration-[#E5E5E5]/30 hover:decoration-[#E5E5E5] transition-colors uppercase">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}